export const env = {
  apiUrl: "",
  production: true,
  accounting: "https://accounting-service.es.mpu.gov.ua/accounting/v1",
  signWidgetUrl: "https://test.id.gov.ua/sign-widget/v2022testnew/",
  realmClientId: "estock-ui-client",
  realmUrl: "https://iam.es.mpu.gov.ua/auth/realms/eStock",
  activeLocale: "uk",
  eStockHomePage: "https://e-stock.gov.ua/",
  documentApi: "https://document-service.es.mpu.gov.ua/v1",
  logisticsServiceBackend: "https://logistics-service.es.mpu.gov.ua"
};
